/**
 * guestIdentity — Persistent anonymous identity for unauthenticated users.
 *
 * Stores a UUID v4 in localStorage under 'dukkan_guest_id'.
 * Created on first call and reused on subsequent calls.
 * Also provides a display name (stored in 'dukkan_guest_name').
 */

const GUEST_ID_KEY = 'dukkan_guest_id'
const GUEST_NAME_KEY = 'dukkan_guest_name'

function uuidv4(): string {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID()
  }
  // Fallback for older browsers
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0
    const v = c === 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}

/** Get or create the persistent guest ID */
export function getGuestId(): string {
  try {
    let id = localStorage.getItem(GUEST_ID_KEY)
    if (!id) {
      id = uuidv4()
      localStorage.setItem(GUEST_ID_KEY, id)
    }
    return id
  } catch {
    // localStorage unavailable (private browsing restrictions, etc.)
    return uuidv4()
  }
}

/** Get or set a display name for the guest */
export function getGuestName(): string {
  try {
    return localStorage.getItem(GUEST_NAME_KEY) || 'Visitor'
  } catch {
    return 'Visitor'
  }
}

export function setGuestName(name: string): void {
  try {
    localStorage.setItem(GUEST_NAME_KEY, name.trim() || 'Visitor')
  } catch {
    // ignore
  }
}
